<ion-card [ngClass]="{'no-box-shadow': !borderShadow}">
  <ion-card-content>
    <ion-row>
      <ion-col>
        <aaa-text [color]="suggested ? 'danger' : 'text'" display="block" size="subheadline" weight="bold" class="destination-name">
          {{ title }}
        </aaa-text>
        <aaa-text weight="semibold" class="distance-status">
          <p>
            <aaa-text size="footnote" display="inline" color="subtle">
              <app-distance-display [distance]="distance" [short]="true"></app-distance-display>
            </aaa-text>
            <app-facility-status-variant [status]="status" [operatingDays]="operatingDays" class="facility-status"></app-facility-status-variant>
            <aaa-text size="caption2" display="inline" color="faint" weight="regular">
              <app-facility-next-date class="facility-next-date" [operatingDays]="operatingDays"></app-facility-next-date>
            </aaa-text>
          </p>
        </aaa-text>
      </ion-col>

      <ion-col size="auto" *ngIf="suggested">
        <ion-row class="ion-align-items-center closest-badge">
          <aaa-text size="headline" display="flex" color="danger">
            <ion-icon src="assets/drrweb-lib/images/icons/bolt-filled.svg"></ion-icon>
          </aaa-text>
          <aaa-text i18n size="footnote" display="inline" color="danger" weight="medium">
            Suggested
          </aaa-text>
        </ion-row>
      </ion-col>
    </ion-row>

    <ng-content select="[content]"></ng-content>

    <ng-content select="[footer]"></ng-content>
  </ion-card-content>
</ion-card>
